/** Preferred public origin. All canonicals, sitemaps, and production fallbacks use this. */
export const SITE_ORIGIN = "https://www.certlynx.com";
export const PREFERRED_HOST = "www.certlynx.com";
export const APEX_HOST = "certlynx.com";

export function hostnameFromHostHeader(host: string | null | undefined): string {
  return (host ?? "").split(":")[0].toLowerCase();
}

export function isApexHost(host: string | null | undefined): boolean {
  return hostnameFromHostHeader(host) === APEX_HOST;
}

/** Absolute URL on the preferred host. `path` may be empty, `/`, or a path like `/about`. */
export function absoluteUrl(path = "/"): string {
  const origin = SITE_ORIGIN.replace(/\/$/, "");
  if (!path || path === "/") return origin;
  return `${origin}${path.startsWith("/") ? path : `/${path}`}`;
}
